import "./_add-distribution-button-dropdown.scss";
import React, {useRef, useState} from "react";
import useProfileEditableState from "../../../hooks/useProfileEditableState";
import {Dropdown, DropdownItem} from "../../../components";
import {DistributionType, DropdownItemType} from "../../model/EstateFlowchartTypes";

type AddDistributionButtonDropdownProps = {
    className: string,
    items: DropdownItemType[];
    handleAddDistribution?: (distributionType: DistributionType) => void
    shouldDropdownOpenUp?: boolean;
}

export const AddDistributionButtonDropdown: React.FC<AddDistributionButtonDropdownProps> = (
    {
        className,
        items,
        handleAddDistribution,
        shouldDropdownOpenUp = false
    }) => {

    const {isProfileWithProposalsOrArchived} = useProfileEditableState();
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);


    const handleClick = () => {
        setIsOpen(!isOpen);
        if (isOpen && dropdownRef.current) {
            dropdownRef.current.focus();
        }
    }

    return (
        <div tabIndex={-1} ref={dropdownRef}>
            <Dropdown
                className={className}
                key={shouldDropdownOpenUp ? "dropup" : "dropdown"}
                alignRight={false}
                buttonIcon="left"
                buttonKind="primary"
                dropdownKind="menu"
                defaultText="Add Distribution"
                iconNameOpen="add"
                iconNameClose="add"
                panelWidth={245}
                dropUp={shouldDropdownOpenUp}
                rounded
                disabled={isProfileWithProposalsOrArchived}
                onClick={handleClick}
            >
                {items.map((item: any, i: number) =>
                    <DropdownItem key={i}
                                  itemText={item.name}
                                  value={item.name}
                                  onClick={() => handleAddDistribution?.(item.type)}
                                  disabled={item.disabled}
                    />)}
            </Dropdown>
        </div>
    );

};